<template>
  <div>
    <div class="footList">
      <div class="footList_list">
        <div class="footList_top">
          <div class="footList_top_left">
            <div class="footList_top_left_login_image">
              <img
                src="../assets/image/logoBottom.png"
                width="100"
                height="40"
              />
            </div>
            <div class="footList_top_left_text">
              <p class="footList_top_left_text_adress">
                浙江省杭州市上城区民心路280号<br />平安金融中心B座8楼
              </p>
              <p class="footList_top_left_text_tel">
                官方热线:0571-81672616
              </p>
              <p class="footList_top_left_text_per">
                官方邮箱：jp1@jiapei-mail.com
              </p>
              <p class="footList_top_left_text_heruo">
                商务合作：15857119515
              </p>
            </div>
            <div>
              <el-row :gutter="20">
                <el-col
                  :span="6"
                  v-for="(item, index) in imageList"
                  :key="index"
                >
                  <div class="imageCurList">
                    <img
                      class="smImg"
                      :src="item.path"
                      @mouseleave="mouseleaveBth(index)"
                      @mouseenter="mouseoverBth(index)"
                      width="48"
                      height="48"
                    />
                    <img
                      class="hoverImage"
                      :class="item.show ? 'opacity' : ''"
                      :src="item.pathHover"
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="footList_top_right">
            <ul class="footList_top_right_list">
              <li v-for="(item, index) in bottomData" :key="index">
                <p class="footList_top_right_list_title">
                  {{ item.title }}
                </p>
                <dd
                  v-for="(itemchild, num) in item.children"
                  :key="num"
                  @click="changeWindow(itemchild)"
                >
                  {{ itemchild.value }}
                </dd>
              </li>
            </ul>
            <img src="../assets/image/bottomFont.png" style="position: absolute;bottom: -120px;right: 95px;width:400px;">
          </div>
        </div>
        <div class="footList_bottom">
          <div class="footList_bottom_news">
            <div class="footList_bottom_news_list">
              <div class="footList_bottom_news_list_left">
                <strong
                  >@2017-2025JIAPEL.COM, Al Rights Reserved
                  浙ICP证130160号浙公网安备33010202002126号</strong
                >
              </div>
              <div class="footList_bottom_news_list_right">
                <strong>服务条款<span style="margin: 0 10px">隐私政策</span>Cookie政策</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "底部",
  data() {
    return {
      imageList: [
        {
          path: require("../assets/image/footer/wx.png"),
          pathHover: require("../assets/image/footer/wxHoverTop.png"),
          url: require("../assets/image/footer/wx.png"),
          hover: require("../assets/image/footer/wxHover.png"),
          show: false
        },
        {
          path: require("../assets/image/footer/xhs.png"),
          pathHover: require("../assets/image/footer/xhsHoverTop.png"),
          url: require("../assets/image/footer/xhs.png"),
          hover: require("../assets/image/footer/xhsHover.png"),
          show: false
        },

        {
          path: require("../assets/image/footer/wb.png"),
          pathHover: require("../assets/image/footer/wbHoverTop.png"),
          url: require("../assets/image/footer/wb.png"),
          hover: require("../assets/image/footer/wbHover.png"),
          show: false
        },
        {
          path: require("../assets/image/footer/dy.png"),
          pathHover: require("../assets/image/footer/dyHoverTop.png"),
          url: require("../assets/image/footer/dy.png"),
          hover: require("../assets/image/footer/dyHover.png"),
          show: false
        }
      ],
      bottomData: [
        {
          title: "公司产品",
          children: [
            {
              key: "VR",
              value: "亚场馆全景平台",
              show: false
            },
            {
              key: "FeiHan",
              value: "飞函邀请函",
              show: false
            },
            {
              key: "enterprse",
              value: "企全景平台",
              show: false
            }
          ]
        },
        {
          title: "解决方案",
          children: [
            {
              key: "hotel",
              value: "酒店行业",
              show: false
            },
            {
              key: "wenBo",
              value: "文博行业",
              show: false
            },
            {
              key: "wenTi",
              value: "文体行业",
              show: false
            },
            {
              key: "firm",
              value: "政企行业",
              show: false
            }
          ]
        },
        {
          title: "资源中心",
          children: [
            {
              key: "Partners",
              value: "合作伙伴",
              show: false
            },
            {
              key: "",
              value: "客户案例",
              show: false
            },
            {
              key: "",
              value: "市场活动",
              show: false
            },
            {
              key: "Partners",
              value: "新闻资讯",
              show: false
            }
          ]
        },
        {
          title: "关于我们",
          children: [
            {
              key: "aboutUs",
              value: "公司介绍",
              show: false
            },
            {
              key: "",
              value: "发展历程",
              show: false
            },
            {
              key: "",
              value: "招商加盟",
              show: false
            },
            {
              key: "",
              value: "联系我们",
              show: false
            }
          ]
        }
      ]
    };
  },
  methods: {
    mouseleaveBth(num) {
      this.imageList[num].path = this.imageList[num].url;
      this.imageList[num].show = false;
    },
    mouseoverBth(num) {
      this.imageList[num].path = this.imageList[num].hover;
      this.imageList[num].show = true;
    },
    changeWindow(val) {
      if (val.key != "") {
        this.$router.push(val.key);
        this.changrTop();
      }
    },
    changrTop() {
      this.$emit("refresh");
    }
  }
};
</script>

<style scoped scoped lang="less">
.footList_bottom_news_list_left {
  color: #666666;
}
.footList_bottom_news_list_right {
  color: #333333;
}
.imageCurList {
  position: relative;
  .smImg {
    cursor: pointer;
  }
  .hoverImage {
    position: absolute;
    top: -127px;
    left: -24px;
    width: 100px;
    height: 120px;
    z-index: 10000;
    opacity: 0;
  }
}
.opacity {
  opacity: 1 !important;
  transition: all 0.5s ease;
}
.footList {
  width: 100%;
  background: #c8c8c8;
  height: 500px;
  .footList_list {
    max-width: 1360px;
    min-width: 1200px;
    margin: auto;
    padding-top: 70px;
    .footList_top:after {
      clear: both;
      content: "";
      display: block;
    }
    .footList_top {
      font-family: "苹方";
      .footList_top_left {
        width: 270px;
        float: left;
        margin-left: 10px;
        .footList_top_left_text {
          color: #333333;
        }
        .footList_top_left_login_image {
          margin-bottom: 10px;
        }
        .footList_top_left_text_adress,
        .footList_top_left_text_tel,
        .footList_top_left_text_per,
        .footList_top_left_text_heruo {
          font-size: 14px;
        }
        .footList_top_left_text_tel {
          margin: 10px 0;
        }
        .footList_top_left_text_per {
          margin-bottom: 10px;
        }
        .footList_top_left_text_heruo {
          margin-bottom: 20px;
        }
      }
      .footList_top_right {
        float: left;
        width: calc(100% - 300px);
        margin-top: 10px;
        position:relative;
        .footList_top_right_list {
          display: flex;
          color: #666666;
          li {
            flex: 1;
            text-align: center;
            .footList_top_right_list_title {
              font-size: 16px;
              margin-bottom: 20px;
              font-weight: bold;
            }
            dd {
              font-size: 14px;
              margin-top: 10px;
              cursor: pointer;
            }
            dd:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .footList_bottom {
      margin-top: 70px;
      .footList_bottom_news {
        width: 100%;
        padding-top: 10px;
        border-top: 1px solid #616060;
        .footList_bottom_news_list {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/footer.vue